









































































































































































































































































































































// vendor
import { defineComponent, PropType, ref, computed } from "@vue/composition-api";
import Draggable from "vuedraggable";
// project
import { pascalToSentenceCase } from "@/utils/text";
import * as AppModal from "@/AppModal";
import { ContextOption } from "@/components.generic/context-menu";
// local
import AddItemButton from "./add-section-item-button.vue";
import * as ItemTypes from "../ts/ItemTypes";
import { FormSection } from "../ts/types";
// import FormItemContext from "./form-item-context.vue";
// import FormSectionContext from "./form-section-context.vue";


const shuffleOptions = [
	{ text: "None", value: null, tooltip: "Display all sections", icon:"mdi.shuffle-disabled" },
	{ text: "Shuffle", value: "shuffle", tooltip: "Display sections in random order", icon:"mdi.shuffle" },
	{ text: "Pick One", value: "select", tooltip: "Display one section at random", icon:"mdi.numeric-1-box" }
];



type Config = {
	sections:FormSection[]
};

const dragOptions = {
	animation: 200,
	disabled: false,
	ghostClass: "ghost",
	forceFallback: true,
};

export default defineComponent({

	props:{
		config:{
			type:Object as PropType<Config>,
			required:true
		},
		activeSection:{
			type:String
		},
		sectionSelection:{
			type:String
		}
	},
	components:{
		AddItemButton,
		Draggable,
		// FormItemContext,
		// FormSectionContext
	},
	setup(props, context){

		// const formItemContext = ref<any>();
		// const formSectionContext = ref<any>();

		const sections = computed(() => props.config && props.config.sections ? props.config.sections : []);

		const displaySections = computed(() => {
			let result:any = [];
			sections.value.forEach((ti:any) => {
				result.push({
					id: ti.id,
					items: ti.items
				});
			});
			return result;
		});


		const isSectionActive = (section:any) => {
			return props.activeSection === section.id;
		};

		const selectSection = (section:any) => {
			context.emit("selectSection", section.id);
		};

		const addSection = () => {
			context.emit("addSection");
		};

		const addItem = (section:any, type:string) => {
			context.emit("addFormItem", {
				section: section.id,
				type
			});
		};

		const deleteSection = (id:string) => {
			context.emit("deleteSection", id);
		};

		const duplicateSection = (id:string) => {
			context.emit("duplicateSection", id);
		};

		// const sectionSelection = computed({
		// 	get:() => props.sectionSelection,
		// 	set(v){
		// 		// props.data.settings.sectionSelection = v;
		// 		context.emit("set-selection", v);
		// 		// set(props.data.settings, "sectionSelection", v);
		// 	}
		// });

		const currentSectionOrder = computed(() => {
			return shuffleOptions.find(o => o.value === props.sectionSelection ) || { value: null, text: "none" };
		});

		// const deleteItem = (s:{ id:string }) => {
		// 	const { id } = s;
		// 	context.emit("deleteFormItem", id);
		// };
		const deleteItem = (id:string) => {
			context.emit("deleteFormItem", id);
		};

		const getTypeIcon = (type:string) => {
			return (ItemTypes as any)[type].icon;
		};

		const openSectionContext = (e:Event, sectionId:string) => {
			// let ctx:any = this.$refs["section_ctx_" + section.id];
			// if(ctx.length > 0){
			// 	setTimeout(() => 	ctx[0].open($event, 0));
			// }
			// if(!formSectionContext.value){ return; }
			// formSectionContext.value.open(e, sectionId);

			const options:ContextOption[] = [
				{
					name:"Duplicate Section",
					icon:"mdi.content-duplicate",
					fn(){
						duplicateSection(sectionId);
					}
				},
				
			];

			if(sections.value.length > 1){
				options.push({
					name:"Delete Section",
					icon:"mdi.trash-can",
					fn(){
						deleteSection(sectionId);
					},
					order:1
				})
			}
			

			AppModal.context(e, options);

		};

		// const duplicateItem = (it:{ id:any }) => {
		// 	const { id } = it;
		// 	context.emit("duplicateItem", id);
		// }
		const duplicateItem = (id:string) => {
			context.emit("duplicateItem", id);
		};

		const openContext = (e:Event, itemId:string) => {
			// let ctx:any = this.$refs[refId];
			// if(ctx.length > 0){
			// 	setTimeout(() => 	ctx[0].open($event, 0));
			// }
			// if(!formItemContext.value){ return; }

			// formItemContext.value.open(e, itemId);


			AppModal.context(e, [
				{
					name:"Duplicate Item",
					icon:"mdi.content-duplicate",
					fn(){
						duplicateItem(itemId);
					}
				},
				{
					name:"Delete Item",
					icon:"mdi.trash-can",
					fn(){
						deleteItem(itemId);
					},
					order:1
				}
			]);

		}

		return {
			// formItemContext,
			// formSectionContext,
			sections,
			displaySections,
			dragOptions,
			pascalToSentenceCase,
			isSectionActive,
			selectSection,
			addSection,
			addItem,
			deleteSection,
			duplicateSection,
			deleteItem,
			getTypeIcon,
			openSectionContext,
			duplicateItem,
			openContext,
			shuffleOptions,
			currentSectionOrder,
		};
	}
});

